import React, { Component, Fragment, ReactNode } from 'react';
import {
  ExpressionTokenComponent,
  StandardExpressionBuilderView,
  GroupToken,
  TokenVariable,
  Syntax,
  ExpressionBuilderView,
  ExpressionContextMenuComponent,
  ElasticsearchFilterExpressionProfile,
} from '@trlogic/ui-pack';
import { createPortal } from 'react-dom';
import DataType from '../../../../constant/DataType';
import { subscribe } from '@trlogic/client-js';
import generateUUIDV4 = subscribe.generateUUIDV4;
import _ from 'lodash';
import { ExpressionUtil } from '../../../../util/ExpressionUtil';

class ChartElasticExpressionComponent extends Component<Props, State> {
  public state: State = new State();

  public render(): ReactNode {
    const { expression, expressionView } = this.state;
    const { id } = this.props;

    return (
      <div className='bg-[#FAFAFA] border-[f-black-5] border-[0.5px] rounded-[2px] w-full' id={`expression_builder_${id}`}>
        <div>
          {expression && expressionView && (
            <Fragment>
              {createPortal(<ExpressionContextMenuComponent context={expressionView.getContext()} close={this.onCloseContextMenu} />, document.body)}
              <ExpressionTokenComponent syntax={expressionView.getModel()} view={expressionView} />
            </Fragment>
          )}
        </div>
      </div>
    );
  }

  public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevProps.variables !== this.props.variables) {
      this.state.expressionView?.getContext().setVariables(_.cloneDeep(this.props.variables));
    }
  }

  public async componentDidMount() {
    this.build();
  }

  public build() {
    let expression = this.state.expression;
    let variables = this.state.variables;
    if (this.props.syntax) expression = this.props.syntax;
    if (this.props.variables) variables = this.props.variables;
    const expressionView: ExpressionBuilderView = new StandardExpressionBuilderView({
      el: `#expression_builder_${this.props.id}`,
      model: expression,
      profile: new ElasticsearchFilterExpressionProfile(),
      returnType: { dataType: DataType.BOOLEAN },
      onCtrlToken: ExpressionUtil.onNavigateToken,
    });
    expressionView.getContext().setVariables(_.cloneDeep(variables));
    expressionView.onChange(this.onChangeSyntax as VoidFunction);
    this.setState({ expressionView, expression }, () => expressionView.initialize());
  }

  public componentWillUnmount() {
    const { expressionView } = this.state;
    expressionView?.terminate();
  }

  private onChangeSyntax = (updatedExpression: Syntax): void => {
    const { onChangeSyntax } = this.props;
    this.setState({ expression: updatedExpression });
    onChangeSyntax(updatedExpression);
  };

  private onCloseContextMenu() {}
}

interface Props {
  syntax: Syntax;
  variables: Record<string, TokenVariable[]>;
  onChangeSyntax: (syntax: Syntax) => void;
  id: string;
}

class State {
  expressionView: ExpressionBuilderView | undefined;
  variables: Record<string, TokenVariable[]> = {};
  expression: Syntax = {
    id: generateUUIDV4(),
    value: {
      type: 'TokenGroup',
      properties: { dataType: DataType.BOOLEAN },
    } as GroupToken,
    children: [],
  };
}

export default ChartElasticExpressionComponent;
